export const getLogoUrl = (domain: string, logoVariant: string = "svg") => {
  return `http://media.${domain
    .replace("prep.", "")
    .replace("stg.", "")
    .replace("live.", "")}/logo_${logoVariant}.svg`;
};

export const getDomain = () =>
  (isLocalhost() && process.env.REACT_APP_DOMAIN) || window.location.hostname;

export const isLocalhost = () => {
  return (
    window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(window.location.hostname)
  );
};

export const mergeClassNames = (classNames: any[]) =>
  classNames.filter((className) => typeof className === "string").join(" ");

export const splitLinkLabel = (label: string) => {
  if (!label.includes("<link>") || !label.includes("</link>")) {
    throw new Error("Missing <link> tags");
  }
  const [prefix, rest] = label.split("<link>");
  const [content, suffix] = rest.split("</link>");
  return {
    content,
    prefix,
    suffix,
  };
};
